var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},[_c('layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageIsLoaded),expression:"pageIsLoaded"}],key:1}),_vm._v(" "),(!_vm.pageIsLoaded)?_c('preloader',{key:2}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3c28174","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 67
// module chunks = 0